import type { WaybillFields } from "./print-waybill.helper";

/**
 * @deprecated Temporary per-organization waybill override (INTEG-258).
 *
 * ТОО «Алтын Тазалық» has no normalised work schedule and fills the standard
 * form differently from the other providers, while the waybill is not yet
 * configurable per organization. This module hard-codes that layout for the
 * one organization. Remove this file together with its single call in
 * `print-waybill.helper.ts` once the waybill is driven by organization
 * settings; nothing else depends on it.
 */
const ALTYN_TAZALYK_ORGANIZATION_ID = 17118;

const ALTYN_TAZALYK_FIELDS: Partial<WaybillFields> = {
  // "Режим работы" and "Колонна" rows stay blank: the schedule is not normalised.
  hours: "",
  orgName: "",
  // One date only: the end-of-shift date box is not used on this form.
  nextDate: "",
  companions: "2 грузчика",
  departureHour: "00",
  departureMinute: "00",
  returnToGarage: "По окончанию работы",
  // "Задание водителю → в чье распоряжение" carries the company and the city.
  departure: "ТОО «Алтын Тазалық»",
  arrival: "г.Алматы",
  fuelBrand: "DIT",
};

/** @deprecated See the module note above. */
export const applyAltynTazalykWaybillOverride = (
  fields: WaybillFields,
  organizationId: bigint | number | undefined,
): WaybillFields => {
  // Connect ids are `bigint`, the legacy store's are `number`. A `bigint` past
  // 2^53 loses precision in `Number`, but it cannot round to 17118.
  return Number(organizationId) === ALTYN_TAZALYK_ORGANIZATION_ID
    ? { ...fields, ...ALTYN_TAZALYK_FIELDS }
    : fields;
};
